import Assign from "./Assign/Assign";
import Select from "./Select/Select";
import Remove from "./Remove/Remove";
import Size from "./Size/Size";
import Update from "./Update/Update";
import { types } from "./types";

function Actions(action, showAlert, variables, setOpenVariable) {
  switch (action.actionName) {
    case types.ASSIGN:
      return (
        <Assign
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    case types.SELECT:
      return (
        <Select
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    case types.REMOVE:
      return (
        <Remove
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    case types.SIZE:
      return (
        <Size
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
    case types.UPDATE:
      return (
        <Update
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
        />
      );
      default: break;
  }
}

export default Actions;
